/* eslint-disable no-unused-expressions */
/* eslint-disable no-use-before-define */
import { MODAL_CLOSE, MODAL_OPEN } from 'events';
import KeenSlider from 'keen-slider';
import { component } from 'picoapp';

import choozy from 'utils/choozy';

export default component((node, ctx) => {
  // Set/Remove Active Class
  const controller = {
    currentSlide: '0',
    init: () => {
      view.init();
    },
    setCurrentSlide: (slide) => {
      controller.currentSlide = slide;
    },
  };

  // All things view rendering related
  const view = {
    slides: [],
    images: [],
    modalContents: [],
    isOnInteract: false,
    breakpointMatch: null,
    breakpointListener: null,
    isDesktop: null,
    swiperAnimation: null,
    // Get all the slides and images, add event listeners to each.
    init: () => {
      const { slide, image, modalContent, imageDisplayContainer, swiperContainer } = choozy(node);
      const { modalId } = node.dataset;
      view.modalId = modalId;
      view.images = [].concat(image);
      view.slides = [].concat(slide);
      view.modalContents = modalContent;
      view.breakpointMatch = window.matchMedia(`(min-width: 1025px)`);
      view.isDesktop = view.breakpointMatch.matches;
      let titleContainerOffsetHeight = 0;

      // if it's not desktop, get the height of the image display container which is absolute and takes some bottom space in mobile view.
      // for more accurate overflow calculation.
      if (!view.isDesktop) {
        titleContainerOffsetHeight = imageDisplayContainer.offsetHeight;
      }

      const isContentOverFlowing =
        Array.from(swiperContainer.children).reduce(
          (acc, children) => acc + children.scrollHeight,
          0,
        ) >
        swiperContainer.clientHeight - titleContainerOffsetHeight;

      // if there is enough content, init swiper
      if (isContentOverFlowing) {
        view.initSwiper();
      }

      // subscribe to the breakpoint change event to remove modal in case we switch to desktop view.
      view.breakpointMatch.addEventListener('change', (e) => {
        if (e.matches === view.isDesktop) return;
        view.isDesktop = e.matches;
        controller.setCurrentSlide(null);

        // init swiper on different breakpoints if it overflows there and swiper is not init.
        if (isContentOverFlowing) {
          view.initSwiper();
        }

        view.toggleModal(false);
        view.render();
      });

      // on modal close, start the swiper autoplay.
      ctx.on(MODAL_CLOSE, (state, { id }) => {
        if (id !== modalId) return;
        view.isOnInteract = false;
        view.swiper?.update();
      });

      // set current slide on mouseover to display image on the right on desktop.
      swiperContainer.addEventListener('mouseover', (e) => {
        const targetSlide = e.target;
        if (targetSlide && view.isDesktop) {
          const { index } = targetSlide.dataset;
          controller.setCurrentSlide(index);
          view.isOnInteract = true;
          view.render();
        }
      });

      // on click, open the modal.
      swiperContainer.addEventListener('click', (e) => {
        const targetSlide = e.target;
        if (targetSlide && !view.isDesktop) {
          const { index } = targetSlide.dataset;
          controller.setCurrentSlide(index);
          view.isOnInteract = true;
          view.toggleModal();
          view.render();
        }
      });

      // on mouseleave, remove the current slide.
      swiperContainer.addEventListener('mouseleave', () => {
        if (view.isDesktop) {
          // controller.setCurrentSlide(null);
          view.isOnInteract = false;
          view.render();
        }
      });

      view.render();
    },
    initSwiper: () => {
      view.swiperAnimation = { duration: 15000, easing: (t) => t };
      const swiperContainer = node.querySelector('.keen-slider');
      view.swiper = new KeenSlider(swiperContainer, {
        loop: true,
        slides: {
          perView: 'auto',
        },
        vertical: true,
        created(s) {
          s.moveToIdx(4, true, view.swiperAnimation);
        },
        updated(s) {
          if (view.isOnInteract) return;
          s.moveToIdx(s.track.details.abs + 4, true, view.swiperAnimation);
        },
        animationEnded(s) {
          if (view.isOnInteract) return;
          s.moveToIdx(s.track.details.abs + 4, true, view.swiperAnimation);
        },
      });
    },
    toggleModal: (state = true) => {
      view?.modalContents?.forEach((modalContentEl) => {
        const { index } = modalContentEl.dataset;
        modalContentEl.classList[index === controller.currentSlide ? 'add' : 'remove']('active');
      });
      // Emit the modal open/close event.
      ctx.emit(state ? MODAL_OPEN : MODAL_CLOSE, null, {
        id: view.modalId,
      });
      view.isOnInteract = state;
    },
    render: () => {
      // Toggle the active class to all the images for desktop.
      view.images.forEach((imageEl) => {
        const { index } = imageEl.dataset;
        imageEl.classList[index === controller.currentSlide ? 'add' : 'remove']('active');
      });

      view.slides.forEach((slideEl) => {
        const { index } = slideEl.dataset;
        const { title, text } = choozy(slideEl);
        // Have to do this because group-[.active] is not working. Even adding new variant in tailwind config is not working.
        title.classList[index === controller.currentSlide ? 'add' : 'remove']('active');
        text.classList[index === controller.currentSlide ? 'add' : 'remove']('active');
      });

      if (view.swiper) {
        if (view.isOnInteract) {
          view.swiper?.animator?.stop();
        } else {
          view.swiper.moveToIdx(view.swiper.track.details.abs + 4, true, view.swiperAnimation);
        }
      }
    },
  };

  controller.init();
});
